import { Typography } from "antd";
import { FONT_SIZE, FONT_WEIGHT } from "config/theme/constants";
import styled from "styled-components";

export const NotFoundWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-right: 230px;
`;

export const ImgWrapper = styled.div`
  max-width: 7.5rem;
`;

export const Text = styled(Typography.Text)`
  font-weight: ${FONT_WEIGHT.bold};
  font-size: ${FONT_SIZE.lg};
`;
